import {Box, Button, Divider, Typography} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import FactCheckRoundedIcon from "@mui/icons-material/FactCheckRounded";
import TouchAppRoundedIcon from "@mui/icons-material/TouchAppRounded";

//POS 店員點餐時，閒置的 iPad 變成客人核對畫面；隨時可切回自助點餐
export default function CustomerDisplay({event, storeName, onStartOrder}) {
  const done = event.status === "done";
  const discount = Math.abs(Number(event.discount ?? 0));

  return (
    <Box sx={{height: "100dvh", display: "flex", flexDirection: "column", bgcolor: "#F7F1E8"}}>
      <Box sx={{px: 3, py: 1.75, bgcolor: "#FFF", borderBottom: "1px solid rgba(80,55,40,.1)", display: "flex", alignItems: "center", gap: 1.5}}>
        <FactCheckRoundedIcon color="primary" sx={{fontSize: 34}}/>
        <Box>
          <Typography sx={{fontSize: 24, fontWeight: 950, lineHeight: 1.2}}>{done ? "結帳完成" : "請核對您的餐點"}</Typography>
          <Typography sx={{fontSize: 15, color: "text.secondary"}}>{storeName || "自助點餐"}</Typography>
        </Box>
        {Number(event.method) > 0 && <Box sx={{ml: "auto", px: 1.5, py: .5, borderRadius: 1, bgcolor: "#F3E7D9", fontSize: 17, fontWeight: 900}}>{Number(event.method) === 3 ? "內用" : "外帶"}</Box>}
      </Box>

      {done ? (
        <Box sx={{flex: 1, display: "grid", placeItems: "center", p: 4}}>
          <Box sx={{textAlign: "center"}}>
            <CheckCircleRoundedIcon sx={{fontSize: 110, color: "#2E7D32", animation: "kioskPop .5s ease"}}/>
            <Typography sx={{fontSize: 42, fontWeight: 950, mt: 1}}>感謝惠顧</Typography>
            <Typography sx={{fontSize: 26, fontWeight: 900, color: "text.secondary", mt: 1}}>本次消費 ${Number(event.total ?? 0).toLocaleString()}</Typography>
          </Box>
        </Box>
      ) : (
        <Box sx={{flex: 1, minHeight: 0, display: "grid", gridTemplateColumns: "1fr 340px", gap: 2.5, p: 2.5}}>
          <Box sx={{overflow: "auto", bgcolor: "#FFF", borderRadius: 1.5, border: "1px solid rgba(80,55,40,.12)", p: 2}}>
            {(event.items ?? []).map((item, index) => (
              <Box key={index} sx={{display: "flex", alignItems: "flex-start", gap: 1.5, py: 1.25, pl: item.sub ? 3.5 : 0, borderBottom: "1px solid rgba(80,55,40,.08)", "&:last-of-type": {borderBottom: "none"}}}>
                <Typography sx={{fontSize: 20, fontWeight: 900, minWidth: 44, color: "text.secondary"}}>×{item.qty}</Typography>
                <Box sx={{flex: 1, minWidth: 0}}>
                  <Typography sx={{fontSize: 21, fontWeight: 900}}>{item.sub ? "└ " : ""}{item.name}</Typography>
                  {item.detail?.length > 0 && <Typography sx={{fontSize: 16, color: "text.secondary", mt: .3}}>{item.detail.join("、")}</Typography>}
                  {item.note && <Typography sx={{fontSize: 15.5, color: "primary.main", mt: .3}}>備註:{item.note}</Typography>}
                </Box>
                <Typography sx={{fontSize: 21, fontWeight: 950}}>${Number(item.money ?? 0).toLocaleString()}</Typography>
              </Box>
            ))}
          </Box>
          <Box sx={{alignSelf: "start", p: 2.5, bgcolor: "#FFF", borderRadius: 1.5, border: "1px solid rgba(80,55,40,.12)"}}>
            <Typography sx={{fontSize: 21, fontWeight: 950}}>金額明細</Typography>
            <Box sx={{display: "flex", justifyContent: "space-between", mt: 1.5}}>
              <Typography sx={{fontSize: 17}}>餐點小計</Typography>
              <Typography sx={{fontSize: 17, fontWeight: 800}}>${Number(event.subtotal ?? 0).toLocaleString()}</Typography>
            </Box>
            {discount > 0 && <Box sx={{display: "flex", justifyContent: "space-between", mt: 1}}>
              <Typography sx={{fontSize: 17, color: "#2E7D32"}}>折扣</Typography>
              <Typography sx={{fontSize: 17, fontWeight: 800, color: "#2E7D32"}}>-${discount.toLocaleString()}</Typography>
            </Box>}
            <Divider sx={{my: 1.75}}/>
            <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
              <Typography sx={{fontSize: 19, fontWeight: 900}}>合計</Typography>
              <Typography key={event.total} sx={{fontSize: 38, fontWeight: 950, color: "primary.main", animation: "kioskPop .3s ease"}}>${Number(event.total ?? 0).toLocaleString()}</Typography>
            </Box>
            <Typography sx={{fontSize: 14, color: "text.secondary", mt: 1.5, textAlign: "center"}}>如品項有誤請直接告知店員</Typography>
          </Box>
        </Box>
      )}

      <Box sx={{px: 2.5, py: 1.5, pb: "calc(12px + env(safe-area-inset-bottom, 0px))", bgcolor: "#FFF", borderTop: "1px solid rgba(80,55,40,.12)", display: "flex", alignItems: "center", gap: 2}}>
        <Typography sx={{fontSize: 15, color: "text.secondary", flex: 1}}>{done ? "畫面將自動返回" : "店員正在為您點餐，此畫面即時同步"}</Typography>
        <Button variant="outlined" startIcon={<TouchAppRoundedIcon/>} onClick={onStartOrder} sx={{minWidth: 240, minHeight: 56, fontSize: 18}}>
          我要自助點餐
        </Button>
      </Box>
    </Box>
  );
}
